var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C0.895431 0 0 0.895431 0 2V18C0 19.1046 0.89543 20 2 20H13C14.1046 20 15 19.1046 15 18V5H10V0H2Z",
    fill: "#CB451F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5L10 0V5H15Z",
    fill: "#FF8F6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55851 12.4508C4.94718 12.4508 5.27351 12.5773 5.53751 12.8303C5.80151 13.0833 5.93351 13.4059 5.93351 13.7983C5.93351 14.1906 5.80151 14.5133 5.53751 14.7663C5.27351 15.0193 4.94718 15.1458 4.55851 15.1458H4.04701V16.3008H3.06251V12.4508H4.55851ZM4.55851 14.2108C4.66851 14.2108 4.76018 14.1723 4.83351 14.0953C4.91051 14.0183 4.94901 13.9193 4.94901 13.7983C4.94901 13.6773 4.91051 13.5801 4.83351 13.5068C4.76018 13.4298 4.66851 13.3913 4.55851 13.3913H4.04701V14.2108H4.55851ZM7.81339 12.4508C8.20206 12.4508 8.52839 12.5773 8.79239 12.8303C9.05639 13.0833 9.18839 13.4059 9.18839 13.7983C9.18839 14.1906 9.05639 14.5133 8.79239 14.7663C8.52839 15.0193 8.20206 15.1458 7.81339 15.1458H7.30189V16.3008H6.31739V12.4508H7.81339ZM7.81339 14.2108C7.92339 14.2108 8.01506 14.1723 8.08839 14.0953C8.16539 14.0183 8.20389 13.9193 8.20389 13.7983C8.20389 13.6773 8.16539 13.5801 8.08839 13.5068C8.01506 13.4298 7.92339 13.3913 7.81339 13.3913H7.30189V14.2108H7.81339ZM12.1854 12.4508V13.4023H11.2339V16.3008H10.2494V13.4023H9.29792V12.4508H12.1854Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptIcon);
export default __webpack_public_path__ + "static/media/pptIcon.2bbc7378135ff203cd04b9d8d367ce90.svg";
export { ForwardRef as ReactComponent };